import React, { FC } from 'react';
import '@ingka/svg-icon/dist/style.css';
import '@ingka/aspect-ratio-box/dist/style.css';
import '@ingka/image/dist/style.css';
import '@ingka/switch/dist/style.css';
import '@ingka/forms/dist/style.css';
import '@ingka/list-view/dist/style.css';
import '@ingka/focus/dist/style.css';
import { useFormContext } from 'react-hook-form';
import SolutionsTab from '../SolutionsTab';

const ProjectTabImproveSolutions: FC<{ hideTitle?: boolean }> = ({
  hideTitle,
}) => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();
  const disabledFields = watch('disabledFields');

  const setFormValue = (field: string, value: unknown) => {
    setValue(field, value, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  return (
    <SolutionsTab
      hideTitle={hideTitle}
      disabledFields={disabledFields}
      setValue={setFormValue}
      error={!!errors.solutions?.message}
    />
  );
};

export default ProjectTabImproveSolutions;
